import { requestLogin } from "@/services/user";
import { ActionFunctionArgs } from "react-router-dom";

// 登录在登录代码里，没法在页面前请求
export const loginLoader = async ({ request }: ActionFunctionArgs) => {
  const formData = await request.formData();
  const account = formData.get("account") as string;
  const pass = formData.get("pass") as string;
  // 这里可以加校验
  return requestLogin(account, pass);
};
